import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default function CloseCashoutHistory() {
	const store = useContext(MyBetsStoreContext);
	const t = useTranslation().t;

	if (store == null) {
		return null;
	}

	return (
		<div className="popup__footer">
			<button
				className="popup__btn btn btn--med btn--primary--inverted"
				type="button"
				onClick={store.cashoutStore.closeCashoutHistory}
			>
				{t<string>("COMMON.CLOSE")}
			</button>
		</div>
	);
}
